// extracted by mini-css-extract-plugin
module.exports = {"custom":"_9525b562206eea52634f8d7022fa80cf-less"};